import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Loading from '../../../components/loading';
import api from "../../../api/api";
import ModalErrorMessage from '../../../components/modalErrorMessage/modalErrorMessage';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function ImageModal({ open, onCloseImageModal, onImageSaved, patientId }) {

    const MAX_FILE_SIZE_MB = 10;
    const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

    const [isLoading, setLoading] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [date, setDate] = useState(dayjs());
    const [description, setDescription] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);

    useEffect(() => {
    }, [open]);

    const fileChange = (event) => {
        const file = event.target.files[0];

        if (file.size > MAX_FILE_SIZE_BYTES) {
            setShowErrorMessage(true);
            setErrorMessage(`A imagem excede o limite de ${MAX_FILE_SIZE_MB} MB.`);
            event.target.value = "";
            return;
        }

        if (file && file.type.startsWith('image/')) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setSelectedFile(null);
            setPreview(null);
        }
    };

    const saveImage = () => {
        if (!selectedFile || !description || !date) {
            setShowErrorMessage(true);
            setErrorMessage('Por favor, adicione uma imagem e uma descrição.');
            return;
        }

        const formData = new FormData();
        formData.append('patientId', patientId);
        formData.append('description', description);
        formData.append('date', dayjs(date).format("DD/MM/YYYY"));
        formData.append('file', selectedFile);

        setLoading(true);
        api.post('/images', formData, {
            headers: {
                Authorization: sessionStorage.getItem('token')
            }
        }).then((returnFromApi) => {
            setLoading(false);
            onImageSaved(returnFromApi);
            
        }).catch((returnFromApi) => {
            setLoading(false);
            onImageSaved(returnFromApi);
            console.error(returnFromApi);
        });
    };

    const cancel = () => {
        cleanFields();
        onCloseImageModal();
    }

    function cleanFields() {
        setDate(dayjs());
        setDescription('');
        setSelectedFile(null);
        setPreview(null);
    }

    return (
        <Dialog open={open} fullWidth maxWidth="sm">

            <Loading isToHidden={isLoading === false} />
            {showErrorMessage && <ModalErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

            <DialogTitle>Adicionar Nova Imagem</DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <DatePicker
                        label="Data"
                        value={date}
                        onChange={(newDate) => setDate(newDate)}
                        format="DD/MM/YYYY"
                    />

                    <TextField
                        label="Descrição"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        variant="outlined"
                        fullWidth
                        required
                    />
                    <Button
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                    >
                        Selecionar Imagem
                        <VisuallyHiddenInput type="file" accept="image/jpeg, image/png, image/pdf" onChange={fileChange} />
                    </Button>

                    {preview && (
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Typography variant="subtitle2">Pré-visualização:</Typography>
                            <img src={preview} alt="Pré-visualização" style={{ maxWidth: '100%', maxHeight: '300px', marginTop: '10px', borderRadius: '8px' }} />
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} >Cancelar</Button>
                <Button onClick={saveImage} variant="contained" >Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
}